import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ChangeDetectorRef } from "@angular/core";
import { IRuleElement } from "projects/sepidz-web-framework/src/lib/models";
import { RowState, ControlTypes } from "projects/sepidz-web-framework/src/lib/models/enums";
import { ActivatedRoute } from "@angular/router";
import { MisSetUp } from "projects/sepidz-web-framework/src/lib/models/missetup.model";
import { TranslateService } from "@ngx-translate/core";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { MisSetupService } from "projects/sepidz-web-framework/src/lib/services/missetup.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { InvVoucherHeader } from "src/app/backoffice/inv/models/inv-voucher-header.model";

@Component({
  selector: "setting-detail-resource",
  templateUrl: "./SettingDetailResource.component.html",
  styleUrls: ["./SettingDetailResource.component.scss"],
})
export class SettingDetailResourceComponent implements OnInit, OnDestroy {
  ngUnsubscribe = new Subject<void>();
  tempListData: MisSetUp[];
  dataList: InvVoucherHeader[] = [];
  isCheckboxDisabled: boolean = false;
  systemName: string;
  isShowBg: boolean;
  resouceId: number;
  public formGroup: UntypedFormGroup;

  @Output() public formSettingResourcesChange = new EventEmitter();
  _formSettingResources: IRuleElement[] = [];

  public get formSettingResources(): IRuleElement[] {
    return this._formSettingResources;
  }
  public set formSettingResources(val: IRuleElement[]) {
    this._formSettingResources = val;
    this.formSettingResourcesChange.emit(val);
  }
  @Input()
  public get formSettingPermissions(): MisSetUp[] {
    return this.misSetup.source;
  }

  constructor(
    private _route: ActivatedRoute,
    private misSetup: MisSetupService,
    private translateService: TranslateService,
    private cdr: ChangeDetectorRef
  ) {
    this.resouceId = +this._route.snapshot.queryParams["elements"];
  }
  ngOnDestroy(): void {
    if (this.ngUnsubscribe) {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
    this.tempListData = undefined;
    this.systemName = undefined;
    this.formGroup = undefined;
    this._formSettingResources = undefined;
  }

  setResouce(resource: any) {
    this.systemName = resource;
    this.isShowBg = true;
    this.setFormGroup();
    this.formGroup.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
      console.log(x);
    });
  }
  setFormGroup() {
    let rs = this.getRuleElements(this.systemName);
    let group: any = {};
    rs.forEach((r) => {
      let entity = this.getValue(r.SystemName, r.KeyValue);
      group[r.KeyValue] = new UntypedFormControl({
        value: entity === undefined ? null : entity === "false" ? false : entity === "true" ? true : entity,
        disabled: r.disabled,
      });
    });
    this.formGroup = new UntypedFormGroup(group);
    this.setDisable();
  }
  getRuleElements(systemName: string): IRuleElement[] {
    if (this.formSettingResources === undefined) return [];
    let rs = this.formSettingResources.filter((x) => x.SystemName === systemName);
    return rs;
  }
  ngOnInit(): void {
    this.checkInventoryData();
  }
  checkInventoryData() {
    this.misSetup.getAllInventorySave().subscribe(
      (data) => {
        this.dataList = data;
        this.isCheckboxDisabled = this.dataList.length > 0;
        this.makeruleelement();
        this.cdr.checkNoChanges();
      },
      (error) => {}
    );
  }
  /*-------------------------Start ControlKind Check-----------------------------*/
  IsCheckBox(controlKind: ControlTypes) {
    return controlKind === ControlTypes.Check;
  }
  getTextBoxType(controlKind: ControlTypes) {
    switch (controlKind) {
      case ControlTypes.NumericTextBox:
        return "number";
      case ControlTypes.TimeTextBox:
        return "time";
      default:
        return "text";
    }
  }
  IsTextBox(controlKind: ControlTypes) {
    return controlKind === ControlTypes.TextBox;
  }
  IsRadio(controlKind: ControlTypes) {
    return controlKind === ControlTypes.Radio;
  }
  IsDropDown(controlKind: ControlTypes) {
    return controlKind === ControlTypes.DropDown;
  }
  IsLookup(controlKind: ControlTypes) {
    return controlKind === ControlTypes.lookup;
  }

  IsGrid(controlKind: ControlTypes) {
    return controlKind === ControlTypes.Grid;
  }
  IsNumericTextBox(controlKind: ControlTypes) {
    return controlKind === ControlTypes.NumericTextBox;
  }
  IsTimeTextBox(controlKind: ControlTypes) {
    return controlKind === ControlTypes.TimeTextBox;
  }
  IsCheckAndNumericTextBox(controlKind: ControlTypes) {
    return controlKind === ControlTypes.CheckAndNumericTextBox;
  }
  IsBreak(controlKind: ControlTypes) {
    return controlKind === ControlTypes.Break;
  }

  /*-------------------------End ControlKind Check-----------------------------*/
  /*-------------------------Start CheckBox Methods-----------------------------*/
  public getCheckboxValue(SystemName: string, KeyValue: string): boolean {
    let val = this.getValue(SystemName, KeyValue);
    if (val === undefined) return false;
    return JSON.parse(val);
  }
  /*-------------------------End CheckBox Methods-----------------------------*/
  /*-------------------------Start CheckAndNumericTextBox Methods-----------------------------*/
  getCheckAndNumericTextBoxCheckValue(SystemName: string, KeyValue: string): boolean {
    let result = false;
    let val = this.getValue(SystemName, KeyValue);
    if (val != null && (val instanceof String || val.indexOf(",") > -1)) {
      let parts = val.split(",");
      if (parts && parts.length > 0) result = JSON.parse(parts[0]);
    } else if (val != null && val instanceof Boolean) result = <boolean>val;
    return result;
  }
  getCheckAndNumericTextBoxNumberValue(SystemName: string, KeyValue: string): number {
    let result: number = 0;

    let val = this.getValue(SystemName, KeyValue);
    if (val != null && (val instanceof String || val.indexOf(",") > -1)) {
      let parts = val.split(",");
      if (parts && parts.length > 1) result = new Number(parts[1]).valueOf();
    } else if (val != null && val instanceof Number) result = <number>val;
    return result;
  }
  setCheckAndNumericTextBoxCheckValue(SystemName: string, KeyValue: string, value: any) {
    let val = this.getValue(SystemName, KeyValue);
    let parts: any[] = [false, 0];
    if (val && (val instanceof String || val.indexOf(",") > -1)) {
      parts = val.split(",");
      if (parts && parts.length > 0) parts[0] = value;
    } else if (val instanceof Number) {
      parts[0] = value;
      parts[1] = val;
    } else {
      parts[0] = value;
      parts[1] = 0;
    }
    val = parts[0].toString() + "," + parts[1].toString();
    this.setValue(SystemName, KeyValue, val);
  }
  setCheckAndNumericTextBoxNumberValue(SystemName: string, KeyValue: string, value: number) {
    let parts = [false, 0];
    let val = this.getValue(SystemName, KeyValue);
    if (val && (val instanceof String || val.indexOf(",") > -1)) {
      let parts = val.split(",");
      if (parts && parts.length > 1) parts[1] = value;
    } else if (val instanceof Boolean) {
      parts[0] = <boolean>val;
      parts[1] = value;
    } else {
      parts[0] = false;
      parts[1] = value;
    }
    val = parts[0].toString() + "," + parts[1].toString();
    this.setValue(SystemName, KeyValue, val);
  }
  /*-------------------------End CheckAndNumericTextBox Methods-----------------------------*/
  public checkboxChangeValue(systemName: string, KeyValue: string, event: any) {
    this.setValue(systemName, KeyValue, event);
  }

  getLookupValue(SystemName: string, KeyValue: string): number {
    let result: any = undefined;
    let val = this.getValue(SystemName, KeyValue);
    if (!val) return result;
    return JSON.parse(val);
  }
  /*-------------------------General-----------------------------*/
  public getValue(SystemName: string, KeyValue: string): any {
    if (!this.formSettingPermissions) this.misSetup.getall();
    if (this.formSettingPermissions === undefined) return undefined;
    let items = this.formSettingPermissions.filter((x) => x.SystemName === SystemName && x.KeyValue === KeyValue);
    if (items === undefined || items.length === 0) {
      let rules = this.getRuleElements(SystemName).filter((x) => x.SystemName === SystemName && x.KeyValue === KeyValue);
      if (rules === undefined || rules.length === 0 || !rules[0].DataValue) return null;
      else if (rules[0] && rules[0].DataValue) return String(rules[0].DataValue).trim();
    } else {
      if (items[0] && items[0].DataValue) return String(items[0].DataValue).trim();
    }
    return undefined;
  }
  public setValue(SystemName: string, KeyValue: string, value: any) {
    if (this.formSettingPermissions) {
      if (!this.formSettingPermissions.some((x) => x.SystemName === SystemName && x.KeyValue === KeyValue)) {
        this.formSettingPermissions.push(<MisSetUp>{ State: RowState.New, SystemName: SystemName, KeyValue: KeyValue, DataValue: value });
      } else {
        this.formSettingPermissions.find((x) => x.SystemName === SystemName && x.KeyValue === KeyValue).DataValue = value;

        if (this.formSettingPermissions.find((x) => x.SystemName === SystemName && x.KeyValue === KeyValue).State != RowState.New)
          this.formSettingPermissions.find((x) => x.SystemName === SystemName && x.KeyValue === KeyValue).State = RowState.Modify;
      }
    }
  }

  /*-------------------------General-----------------------------*/
  makeruleelement() {
    if (!this._formSettingResources) this._formSettingResources = [];
    //#region ACC
    let re: IRuleElement = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.GroupIdLength");
    re.SystemName = "ACC";
    re.ControlType = ControlTypes.NumericTextBox;
    re.KeyValue = "PLLEN";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.KolIdLegth");
    re.SystemName = "ACC";
    re.ControlType = ControlTypes.NumericTextBox;
    re.KeyValue = "GLLEN";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.SubLedureLength");
    re.SystemName = "ACC";
    re.ControlType = ControlTypes.NumericTextBox;
    re.KeyValue = "SLLEN";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.DetailLedureLength");
    re.SystemName = "ACC";
    re.ControlType = ControlTypes.NumericTextBox;
    re.KeyValue = "DLLEN";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.DetailLedureLevel");
    re.SystemName = "ACC";
    re.ControlType = ControlTypes.NumericTextBox;
    re.KeyValue = "DLLEVEL";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.SystemName = "ACC";
    re.ControlType = ControlTypes.Break;
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.CopyHeaderTitleToDetailTitle");
    re.SystemName = "ACC";
    re.ControlType = ControlTypes.Check;
    re.KeyValue = "CopyHeaderTitleToDetailTitle";
    this._formSettingResources.push(re);
    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.VoucherNumberBranchSeparate");
    re.SystemName = "ACC";
    re.ControlType = ControlTypes.Check;
    re.KeyValue = "VoucherNumberBranchSeparate";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.ToDayDate");
    re.SystemName = "ACC";
    re.ControlType = ControlTypes.Check;
    re.KeyValue = "ToDayDate";
    this._formSettingResources.push(re);
    //#endregion
    //#region INV

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.GoodsCodeLength");
    re.SystemName = "INV";
    re.ControlType = ControlTypes.NumericTextBox;
    re.KeyValue = "GoodsCodeLength";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.AccountsPayableSubLedger");
    re.SystemName = "INV";
    re.ControlType = ControlTypes.lookup;
    re.KeyValue = "AccountsPayableSubLedger";
    re.apiName = "SubLedger/GetPagining";
    re.displayMember = "Title";
    re.columnsName = "Title,Code";
    re.valueMember = "Id";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.Cashdiscountsonpurchases");
    re.SystemName = "INV";
    re.ControlType = ControlTypes.lookup;
    re.KeyValue = "Cashdiscountsonpurchases";
    re.apiName = "SubLedger/GetPagining";
    re.displayMember = "Title";
    re.columnsName = "Title,Code";
    re.valueMember = "Id";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.SurplusageSubLedger");
    re.SystemName = "INV";
    re.ControlType = ControlTypes.lookup;
    re.KeyValue = "SurplusageSubLedger";
    re.apiName = "SubLedger/GetPagining";
    re.displayMember = "Title";
    re.columnsName = "Title,Code";
    re.valueMember = "Id";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.DeductionSubLedger");
    re.SystemName = "INV";
    re.ControlType = ControlTypes.lookup;
    re.KeyValue = "DeductionSubLedger";
    re.apiName = "SubLedger/GetPagining";
    re.displayMember = "Title";
    re.columnsName = "Title,Code";
    re.valueMember = "Id";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.TransportInterfaceSubLedger");
    re.SystemName = "INV";
    re.ControlType = ControlTypes.lookup;
    re.KeyValue = "TransportInterfaceSubLedger";
    re.apiName = "SubLedger/GetPagining";
    re.displayMember = "Title";
    re.columnsName = "Title,Code";
    re.valueMember = "Id";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.AutoGoodsNum");
    re.SystemName = "INV";
    re.ControlType = ControlTypes.Check;
    re.KeyValue = "AutoGoodsNum";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.NegativeBalance");
    re.SystemName = "INV";
    re.ControlType = ControlTypes.Check;
    re.KeyValue = "NegativeBalance";
    this._formSettingResources.push(re);

    // re = <IRuleElement>{};
    // re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.ClassificationPricingMethodIs");
    // re.SystemName = "INV";
    // re.ControlType = ControlTypes.Check;
    // re.KeyValue = "ClassificationPricingMethodIs";
    // re.disabled = true;
    // this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.IsGroupByWithGoods");
    re.SystemName = "INV";
    re.ControlType = ControlTypes.Check;
    re.KeyValue = "IsGroupByWithGoods";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.SingleOrIngredients");
    re.SystemName = "INV";
    re.ControlType = ControlTypes.Check;
    re.KeyValue = "SingleOrIngredients";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.WarehouseGoodsRelation");
    re.SystemName = "INV";
    re.ControlType = ControlTypes.Check;
    re.KeyValue = "WarehouseGoodsRelation";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.NetWithNoTax");
    re.SystemName = "INV";
    re.ControlType = ControlTypes.Check;
    re.KeyValue = "NetWithNoTax";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.CostBasedPricing");
    re.SystemName = "INV";
    re.ControlType = ControlTypes.Check;
    re.KeyValue = "CostBasedPricing";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.HasTransferee");
    re.SystemName = "INV";
    re.ControlType = ControlTypes.Check;
    re.KeyValue = "HasTransferee";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.DisableReferenceDocument");
    re.SystemName = "INV";
    re.ControlType = ControlTypes.Check;
    re.KeyValue = "DisableReferenceDocument";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.CostBasedPricingForce");
    re.SystemName = "INV";
    re.ControlType = ControlTypes.Check;
    re.KeyValue = "CostBasedPricingForce";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.CheckWarehouseTransferDuplicated");
    re.SystemName = "INV";
    re.ControlType = ControlTypes.Check;
    re.KeyValue = "CheckWarehouseTransferDuplicated";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.TransportInterfaceSubLedgerFromWareHous");
    re.SystemName = "INV";
    re.ControlType = ControlTypes.Check;
    re.KeyValue = "TransportInterfaceSubLedgerFromWareHous";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.LinearCalculationMethod");
    re.SystemName = "INV";
    re.ControlType = ControlTypes.Check;
    re.KeyValue = "LinearCalculationMethod";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.VoucherNumberWarehouseSeparate");
    re.SystemName = "INV";
    re.ControlType = ControlTypes.Check;
    re.KeyValue = "VoucherNumberWarehouseSeparate";
    re.disabled = this.isCheckboxDisabled;
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.InvAccVoucherSeparateDate");
    re.SystemName = "INV";
    re.ControlType = ControlTypes.Check;
    re.KeyValue = "InvAccVoucherSeparateDate";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.InvAccVoucherSeparateVoucherKind");
    re.SystemName = "INV";
    re.ControlType = ControlTypes.Check;
    re.KeyValue = "InvAccVoucherSeparateVoucherKind";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.AccVoucherWithNetPrice");
    re.SystemName = "INV";
    re.ControlType = ControlTypes.Check;
    re.KeyValue = "AccVoucherWithNetPrice";
    this._formSettingResources.push(re);
    //#endregion
    //#region  TRS
    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.TrsReceivableSubLedger");
    re.SystemName = "TRS";
    re.ControlType = ControlTypes.lookup;
    re.KeyValue = "TrsReceivableSubLedger";
    re.apiName = "SubLedger/GetPagining";
    re.displayMember = "Title";
    re.columnsName = "Title,Code";
    re.valueMember = "Id";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.TrspayableSubLedger");
    re.SystemName = "TRS";
    re.ControlType = ControlTypes.lookup;
    re.KeyValue = "TrspayableSubLedger";
    re.apiName = "SubLedger/GetPagining";
    re.displayMember = "Title";
    re.columnsName = "Title,Code";
    re.valueMember = "Id";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.SystemName = "TRS";
    re.ControlType = ControlTypes.Break;
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.TrsAccVoucherSeparateDate");
    re.SystemName = "TRS";
    re.ControlType = ControlTypes.Check;
    re.KeyValue = "TrsAccVoucherSeparateDate";
    this._formSettingResources.push(re);
    re = <IRuleElement>{};

    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.TrsAccVoucherSeparateVoucherKind");
    re.SystemName = "TRS";
    re.ControlType = ControlTypes.Check;
    re.KeyValue = "TrsAccVoucherSeparateVoucherKind";
    this._formSettingResources.push(re);
    //#endregion

    //#region  GNR
    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.HasTaxDuty");
    re.SystemName = "GNR";
    re.ControlType = ControlTypes.Check;
    re.KeyValue = "HasTaxDuty";
    this._formSettingResources.push(re);
    re = <IRuleElement>{};

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.TaxRate");
    re.SystemName = "GNR";
    re.ControlType = ControlTypes.NumericTextBox;
    re.KeyValue = "TaxRate";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.TaxSubLedger");
    re.SystemName = "GNR";
    re.ControlType = ControlTypes.lookup;
    re.KeyValue = "TaxSubLedger";
    re.apiName = "SubLedger/GetPagining";
    re.displayMember = "Title";
    re.columnsName = "Title,Code";
    re.valueMember = "Id";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.AdvanceTaxSubLedger");
    re.SystemName = "GNR";
    re.ControlType = ControlTypes.lookup;
    re.KeyValue = "AdvanceTaxSubLedger";
    re.apiName = "SubLedger/GetPagining";
    re.displayMember = "Title";
    re.columnsName = "Title,Code";
    re.valueMember = "Id";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.SystemName = "GNR";
    re.ControlType = ControlTypes.Break;
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.IsActiveBarCodeReader");
    re.SystemName = "GNR";
    re.ControlType = ControlTypes.NumericTextBox;
    re.KeyValue = "IsActiveBarCodeReader";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.ToasterTimeOut");
    re.SystemName = "GNR";
    re.ControlType = ControlTypes.NumericTextBox;
    re.KeyValue = "ToasterTimeOut";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.BackupCleanup");
    re.SystemName = "GNR";
    re.ControlType = ControlTypes.NumericTextBox;
    re.KeyValue = "BackupCleanup";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.SystemName = "GNR";
    re.ControlType = ControlTypes.Break;
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.SystemName = "GNR";
    re.ControlType = ControlTypes.Break;
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.AutoCreateDetailLedger");
    re.SystemName = "GNR";
    re.ControlType = ControlTypes.Check;
    re.KeyValue = "AutoCreateDetailLedger";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.SystemName = "GNR";
    re.ControlType = ControlTypes.Break;
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.SystemName = "GNR";
    re.ControlType = ControlTypes.Break;
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.FullScreenView");
    re.SystemName = "GNR";
    re.ControlType = ControlTypes.Check;
    re.KeyValue = "FullScreenView";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.HasRowAccess");
    re.SystemName = "GNR";
    re.ControlType = ControlTypes.Check;
    re.KeyValue = "HasRowAccess";
    this._formSettingResources.push(re);

    //#endregion
    //#region  SELL
    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.ShowSellLastMonthInList");
    re.SystemName = "SELL";
    re.ControlType = ControlTypes.Check;
    re.KeyValue = "ShowSellLastMonthInList";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.EditAfterPrint");
    re.SystemName = "SELL";
    re.ControlType = ControlTypes.Check;
    re.KeyValue = "EditAfterPrint";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.SystemName = "SELL";
    re.ControlType = ControlTypes.Break;
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.CertainAccountsReceivableSubLedger");
    re.ControlType = ControlTypes.lookup;
    re.KeyValue = "CertainAccountsReceivableSubLedger";
    re.apiName = "SubLedger/GetPagining";
    re.displayMember = "Title";
    re.columnsName = "Title,Code";
    re.valueMember = "Id";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.SellAccVoucherSeparateVoucherKind");
    re.SystemName = "SELL";
    re.ControlType = ControlTypes.Check;
    re.KeyValue = "SellAccVoucherSeparateVoucherKind";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.SellAccVoucherSeparateDate");
    re.SystemName = "SELL";
    re.ControlType = ControlTypes.Check;
    re.KeyValue = "SellAccVoucherSeparateDate";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.EditableGoodsTitle");
    re.SystemName = "SELL";
    re.ControlType = ControlTypes.Check;
    re.KeyValue = "EditableGoodsTitle";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.AccountRemainForCurrentBranch");
    re.SystemName = "SELL";
    re.ControlType = ControlTypes.Check;
    re.KeyValue = "AccountRemainForCurrentBranch";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.PartType");
    re.SystemName = "SG";
    re.ControlType = ControlTypes.NumericTextBox;
    re.KeyValue = "PartType";
    this._formSettingResources.push(re);

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.ReservationLevel");
    re.SystemName = "SG";
    re.ControlType = ControlTypes.NumericTextBox;
    re.KeyValue = "ReservationLevel";
    this._formSettingResources.push(re);

    //#endregion

    re = <IRuleElement>{};
    re.Title = this.translateService.instant("ClientApp.GNR.MisSetup.SettingDetailResource.PersCodeLen");
    re.SystemName = "HRM";
    re.ControlType = ControlTypes.NumericTextBox;
    re.KeyValue = "PersCodeLen";
    this._formSettingResources.push(re);

    this.setFormGroup();
    this.setDisable();
  }
  setDisable() {
    this.misSetup
      .hasAccVoucher()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((x) => {
        if (x) {
          if (this.formGroup.controls["SLLEN"] && this.formGroup?.controls["SLLEN"]?.value) this.formGroup.controls["SLLEN"].disable();
          if (this.formGroup.controls["DLLEVEL"] && this.formGroup?.controls["DLLEVEL"]?.value) this.formGroup.controls["DLLEVEL"].disable();
          if (this.formGroup.controls["DLLEN"] && this.formGroup?.controls["DLLEN"]?.value) this.formGroup.controls["DLLEN"].disable();
        } else {
          if (this.formGroup.controls["SLLEN"]) this.formGroup.controls["SLLEN"].enable();
          if (this.formGroup.controls["DLLEVEL"]) this.formGroup.controls["DLLEVEL"].enable();
          if (this.formGroup.controls["DLLEN"]) this.formGroup.controls["DLLEN"].enable();
        }
        this._formSettingResources.find((x) => x.SystemName === "ACC" && x.KeyValue === "DLLEVEL").disabled =
          x && this.formGroup?.controls["DLLEVEL"]?.value;
        this._formSettingResources.find((x) => x.SystemName === "ACC" && x.KeyValue === "SLLEN").disabled =
          x && this.formGroup?.controls["SLLEN"]?.value;
        this._formSettingResources.find((x) => x.SystemName === "ACC" && x.KeyValue === "DLLEN").disabled =
          x && this.formGroup?.controls["DLLEN"]?.value;
      });

    this.misSetup
      .hasGeneralLedger()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((x) => {
        if (this.formGroup.controls["PLLEN"] && x && this.formGroup?.controls["PLLEN"]?.value) this.formGroup.controls["PLLEN"].disable();
        else if (this.formGroup.controls["PLLEN"]) this.formGroup.controls["PLLEN"].enable();
        this._formSettingResources.find((x) => x.SystemName === "ACC" && x.KeyValue === "PLLEN").disabled =
          x && this.formGroup?.controls["PLLEN"]?.value;
      });
    this.misSetup
      .hasSubLedger()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((x) => {
        if (this.formGroup.controls["GLLEN"] && x && this.formGroup?.controls["GLLEN"]?.value) this.formGroup.controls["GLLEN"].disable();
        else if (this.formGroup.controls["GLLEN"]) this.formGroup.controls["GLLEN"].enable();
        this._formSettingResources.find((x) => x.SystemName === "ACC" && x.KeyValue === "GLLEN").disabled =
          x && this.formGroup?.controls["GLLEN"]?.value;
      });
  }
}
